/**
 * @name NewsDialog
 * @description Modal de todos los avisos de la empresa
 * @author Ricardo Guerra
 */

import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import styled from 'styled-components';

import { DataGrid, FiltersExpansion } from '@components';
import { Icons, MUI } from '@styles';

const NewsDialog = (props) => {
  const {
    news,
    filters,
    open,
    onClose,
    onFilter,
    onClickRow
  } = props;

  const columns = [
    { id: 'IdAvisoGeneral', label: i18n.t('GenericMessages.IdAvisoGeneral'), visible: false, filter: null },
    { id: 'Id', label: i18n.t('GenericMessages.Id'), visible: false, filter: null },
    { id: 'Titulo', label: i18n.t('News.title'), visible: true, filter: null, minWidth: 250 },
    { id: 'Mensaje', label: i18n.t('News.message'), visible: true, filter: null },
    { id: 'Leido', label: i18n.t('GenericMessages.read'), visible: true, filter: 'YesNoFilter' },
    { id: 'FechaInicio', label: i18n.t('GenericMessages.startDate'), visible: true, filter: 'ShortDateFilter' },
    { id: 'FechaFin', label: i18n.t('GenericMessages.expirationDate'), visible: true, filter: 'ShortDateFilter' }
  ];

  return (
    <MUI.Dialog
      open={open}
      onClose={onClose}
      maxWidth="xl"
    >
      <MUI.DialogTitle>
        {`${i18n.t('News.news')}`}
        <MUI.DialogBoxClose onClick={onClose}>
          <Icons.Close />
        </MUI.DialogBoxClose>
      </MUI.DialogTitle>
      <MUI.DialogContent>
        <FiltersExpansion>
          <MUI.Grid container>
            <MUI.Grid
              item
              md={3}
              sm={6}
              xs={12}
            >
              <BoxFilter>
                <MUI.TextField
                  select
                  displayEmpty
                  label={i18n.t('GenericMessages.status')}
                  type="text"
                  name="read"
                  value={filters.read}
                  onChange={(event) => onFilter({ read: event.target.value })}
                >
                  <MUI.SelectOption value={true}>
                    {i18n.t('GenericMessages.read')}
                  </MUI.SelectOption>
                  <MUI.SelectOption value={false}>
                    {i18n.t('GenericMessages.unread')}
                  </MUI.SelectOption>
                  <MUI.SelectOption value={'null'}>
                    {i18n.t('GenericMessages.all')}
                  </MUI.SelectOption>
                </MUI.TextField>
              </BoxFilter>
            </MUI.Grid>
          </MUI.Grid>
        </FiltersExpansion>
        <MUI.Box padding="16px">
          <DataGrid
            columns={columns}
            rows={news}
            isPaginated={true}
            canSort={true}
            canSelect={true}
            onClickRow={onClickRow}
          />
        </MUI.Box>
      </MUI.DialogContent>
      <MUI.DialogActions>
        <MUI.ButtonText onClick={onClose}>
          {i18n.t('DialogConfirm.close')}
        </MUI.ButtonText>
      </MUI.DialogActions>
    </MUI.Dialog>
  );
};

NewsDialog.propTypes = {
  // Array con la información de los avisos de la empresa.
  news: PropTypes.array.isRequired,
  // Filtros de avisos.
  filters: PropTypes.object.isRequired,
  // Boolean que indica si el modal esta abierto.
  open: PropTypes.bool.isRequired,
  // Función que se ejecuta para cerrar el modal.
  onClose: PropTypes.func.isRequired,
  // Función que se ejecuta cuando se aplica un filtro.
  onFilter: PropTypes.func.isRequired,
  // Función que se ejecuta cuando se selecciona un aviso.
  onClickRow: PropTypes.func
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const BoxFilter = styled.div`
  padding: 0 16px;
`;


export default NewsDialog;